export default defineNuxtPlugin(() => {
  window.history.scrollRestoration = 'manual'
  window.scrollTo(0, 0)
  document.documentElement.style.opacity = ''
})
